import ActionsService from '../../services/actions-service/ActionsService'
import AuthService from '../../services/auth-service/AuthService'

export default class SecurityUtils {
    static userMiniappActions = async slug => {
        if (!slug) return []
        try {
            const email = AuthService.getDecodedToken().email
            const actions = await ActionsService.findCheckedActions(email, slug)
            return actions.data
        } catch (e) {
            console.error(
                'Não é possível verificar as actions do usuário, relacionadas a este eitri-app. Verifique se o eitri-app esta sendo fornecido corretamente.',
                e,
            )
        }
    }
}
